<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
html { font-size: 18px; }
body { margin: 0; padding: 0; background: #f7f8fa; }
#app { min-height: 100vh; }

/*
 * Font-size tiers (root 18px):
 *   T1 — Page title     1.167rem (21px)
 *   T2 — Section title  1.056rem (19px)
 *   T3 — Body           0.889rem (16px)
 *   T4 — Small          0.778rem (14px)
 */

/* ═══ T1: Page title ═══ */
.van-nav-bar__title,
.login-header h1,
.settings-header h1 {
  font-size: 1.167rem !important;
}

/* nav-bar sizing */
.van-nav-bar__content {
  height: 3rem !important;
}
.van-nav-bar .van-icon {
  font-size: 1.222rem;
}
.van-nav-bar__text {
  font-size: 1.056rem;
}

/* ═══ T2: Section title ═══ */
.van-cell,
.van-cell__title,
.van-cell-group__title {
  font-size: 1.056rem;
}

/* ═══ T3: Body ═══ */
body,
.van-cell__label,
.van-cell__value,
.van-field__control,
.van-field__label,
.van-button,
.van-tab__text,
.van-dialog__message,
.van-toast__text,
.van-empty__description,
.van-search__field,
.van-dropdown-menu__title,
.van-form-item__label,
.van-checkbox__label,
.van-radio__label,
.van-switch__label,
.van-picker__option,
.van-grid-item__text,
.van-divider,
div, p, li, td, th, label, input, textarea, select {
  font-size: 0.889rem;
}

/* tabbar sizing */
.van-tabbar { height: 3.667rem !important; }
.van-tabbar-item__icon { font-size: 1.667rem !important; }
.van-tabbar-item__text { font-size: 0.944rem !important; }

/* ═══ T4: Small ═══ */
.van-tag,
.van-button--small,
.van-button--mini,
small {
  font-size: 0.778rem;
}

/* active tab emphasis */
.van-tab--active .van-tab__text { font-weight: 600; }

/* text-muted is a color modifier only — inherits font-size from context */
.text-muted { color: #969799; }

/* login/settings subtitle */
.login-header p,
.settings-header p { color: #999; }
</style>
